import axios from 'axios'

const notification_form = {
  namespaced: true,

  state() {
    return {
      data: {
        title: null,
        publication_from: null,
        escape_body: null,
        attachments: [],
      },
    };
  },

  mutations: {
    setData(state, data) {
      state.data.title = data.title;
      state.data.publication_from = data.publication_from;
      state.data.escape_body = data.escape_body;
      state.data.attachments = data.attachments;
    },
  },

  actions: {
    load({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.get('/api/notifications/' + payload.id).then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        }).catch(() => reject());
      });
    },
    download({ commit }, payload){
      return new Promise((resolve, reject) => {
        axios.post(`/api/notification_attachments/${payload.id}/download`).then((response) => {
          let base64 = response.data.data.file;
          let bin = atob(base64.replace(/^.*,/, ''));
          let buffer = new Uint8Array(bin.length);
          for (var i = 0; i < bin.length; i++) {
            buffer[i] = bin.charCodeAt(i);
          }
          const blob = new Blob([buffer.buffer], { type: response.data.data.content_type });
          let link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = response.data.data.file_name;
          link.click();
          window.URL.revokeObjectURL(link.href);
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({ handled });
        });
      });
    },
  }
};

export default notification_form;
